import { combineReducers } from "redux";
import datasourceReducer from "./datasourceReducer";
import pageListReducer from "./pageListReducer";
import appReducer from "./appReducer";

const entityReducer = combineReducers({
  datasources: datasourceReducer,
  pageList: pageListReducer,
  app: appReducer,
});

export default entityReducer;
